import bizTable from '@/biz/bizTable.mjs'

export default bizTable('/basbdts', 'bdtCode', {stsCode: 'ENABLE'})
